var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('v-icon',{staticClass:"download-log",on:{"click":_vm.createFileRequest}},[_vm._v(" mdi-download ")]):_c('v-progress-circular',{attrs:{"indeterminate":"","color":"green"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }